import React from 'react';
import Image from '../../atom/image';
import ReactOtpField from '../../common/ReactOtp/ReactOtpField';
import TNC from '../../atom/otp/tnc';

const PasscodePopup = ({
    showPasscodePopup,
    passcodeValue,
    setPasscodeValue,
    passcodeError,
    passcodeLoading,
    handlePasscodeClose,
    handlePasscodeSubmit,
    handleForgotPasscode,
}) => {
    if (!showPasscodePopup) return null;

    return (
        <div className="popup_wrapper">
            <div className="popup_inner_wrapper popup_inner_wrapper_padding">
                <span
                    onClick={handlePasscodeClose}
                    className="pop_up_close_icon_wrapper_style"
                    disabled={passcodeLoading}
                >
                    <span className="material-icons pop_up_close_icon_style">
                        close
                    </span>
                </span>
                <div className="popup_inner_wrapper_background">
                    <div className="left-section-popup-wrapper">
                        <div className="left-section">
                            <h2 className="headerPopup_new">
                                Your session needs<br />
                                verification before <br />
                                accessing your portfolio. <br />
                                Please complete two-factor authentication(2FA) to <br />
                                continue securely and <br /> enjoy full acess to <br /> your account features.
                            </h2>
                            <Image
                                image="login/grow_more.png"
                                alt="Investment"
                                className="headerImage_popup"
                            />
                        </div>
                    </div>
                    <div className="login-popupbox_new popupbox popupbox_background">
                        <div className="popup_header">Two-Factor Authentication</div>
                        <div className="row">
                            <div className="col-md-12 col-lg-12 otp-input-sec">
                                <p className="passcode-instruction">ENTER PASSCODE</p>
                                <div className="passcode-input-container">
                                    <ReactOtpField
                                        label=""
                                        handleOTP={setPasscodeValue}
                                        otp={passcodeValue}
                                        shouldAutoFocus={true}
                                        isInputSecure={true}
                                        numInputs={4}
                                    />
                                </div>
                                {passcodeError && <div className='passcode-error' style={{ textAlign: 'left' }}>{passcodeError}</div>}
                                <div className="forgotPasscode forgotPasscode_new" onClick={handleForgotPasscode} style={{ textAlign: 'left' }}>Forgot Passcode?</div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12 text-center">
                            <div className="yg_submitWrap">
                                <div className="passcode-buttons">
                                    <button
                                        onClick={handlePasscodeSubmit}
                                        className="btn-submit yg_submitBtn"
                                        disabled={passcodeLoading}
                                    >
                                        {passcodeLoading ? 'Authenticating...' : 'VERIFY NOW'}
                                    </button>
                                    <div className="tncDiv">
                                        <TNC />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasscodePopup;